import { openCashDraw } from '@/utils/printer';
import {
  STORAGE_POS_HOTKEYS_GOTO_LAUNCHER,
  STORAGE_POS_HOTKEYS_GOTO_ORDER,
  STORAGE_POS_HOTKEYS_GOTO_RELOAD,
  STORAGE_POS_HOTKEYS_GOTO_SETTING,
  STORAGE_POS_HOTKEYS_GOTO_USER,
  STORAGE_POS_HOTKEYS_GOTO_WORKBENCH,
  STORAGE_POS_HOTKEYS_OPEN_CASH_DRAW,
} from '@/utils/storage';
import { useCallback } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useNavigate } from 'react-router-dom';
import { useLocalStorage } from 'react-use';

/**
 * 统一管理 POS 快捷键绑定
 * 合并所有 bind* 调用，减少重复的 useLocalStorage / useHotkeys 注册
 */
export function usePosHotkeys() {
  const navigate = useNavigate();

  const [cashDrawKey] = useLocalStorage<string>(STORAGE_POS_HOTKEYS_OPEN_CASH_DRAW, 'f2');
  const [workbenchKey] = useLocalStorage<string>(STORAGE_POS_HOTKEYS_GOTO_WORKBENCH, 'f3');
  const [launcherKey] = useLocalStorage<string>(STORAGE_POS_HOTKEYS_GOTO_LAUNCHER, 'f1');
  const [orderKey] = useLocalStorage<string>(STORAGE_POS_HOTKEYS_GOTO_ORDER, 'f4');
  const [userKey] = useLocalStorage<string>(STORAGE_POS_HOTKEYS_GOTO_USER, 'f5');
  const [settingKey] = useLocalStorage<string>(STORAGE_POS_HOTKEYS_GOTO_SETTING, 'f6');
  const [reloadKey] = useLocalStorage<string>(STORAGE_POS_HOTKEYS_GOTO_RELOAD, 'f9');

  const gotoWorkbench = useCallback(() => navigate('/POS/checkout'), [navigate]);
  const gotoLauncher = useCallback(() => navigate('/POS/index'), [navigate]);
  const gotoOrder = useCallback(() => navigate('/POS/order'), [navigate]);
  const gotoUser = useCallback(() => navigate('/POS/user'), [navigate]);
  const gotoSetting = useCallback(() => navigate('/POS/system'), [navigate]);
  const reload = useCallback(() => {
    location.href = '/POS/checkout';
  }, []);

  useHotkeys(cashDrawKey, openCashDraw, [cashDrawKey]);
  useHotkeys(workbenchKey, gotoWorkbench, [workbenchKey]);
  useHotkeys(launcherKey, gotoLauncher, [launcherKey]);
  useHotkeys(orderKey, gotoOrder, [orderKey]);
  useHotkeys(userKey, gotoUser, [userKey]);
  useHotkeys(settingKey, gotoSetting, [settingKey]);
  useHotkeys(reloadKey, reload, [reloadKey]);
}
